import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { useService } from "@/base/hooks/useService";
import { signInWithTwitch, signInWithTwitter } from "@redux/signIn/actions";
import { StorageService } from "@services/StorageService";
import { localstorageKeys } from "@const/store";

const useOAuth = () => {
  const dispatch = useDispatch();
  const storageService = useService(StorageService);

  const referral = storageService.get(
    localstorageKeys.creatorReferral,
    {},
  ).newCreatorReferralCode;

  const trackingCode = storageService.get(localstorageKeys.trackingCode, "");

  const handleTwitterAuthCallback = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("oauth_token");
    const verifierToken = params.get("oauth_verifier");

    if (token && verifierToken) {
      window.history.pushState({}, "", "/");
      dispatch(
        signInWithTwitter({
          referral,
          token,
          verifierToken,
          trackingCode,
        }),
      );
    }
  };

  const handleTwitchCallback = () => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("code");

    if (!token) return;

    window.history.pushState({}, "", "/");
    dispatch(signInWithTwitch({ token, referral, trackingCode }));
  };

  useEffect(() => {
    handleTwitterAuthCallback();
    handleTwitchCallback();
  }, []);
};

export default useOAuth;
